/**
 * « Réservé aux internes » d'un simulateur dans l'admin (chantier Booster, 19/10/2026 — plan
 * `docs/plans/booster-creation-simulatorid.md`). Coché : seuls l'ADM et le COO voient et lancent le
 * simulateur (`src/lib/simulateurs-internes.ts`). Réglage réservé à l'ADM (`champsReservesAdm`) :
 * pour les autres profils, `locked` l'affiche en lecture.
 */
import { useTranslation } from "react-i18next";
import { Label } from "./ui/label";

export function SimulatorInternalOnlyField({
  value,
  onChange,
  locked = false,
  compact = false,
}: {
  value: unknown;
  onChange: (value: boolean) => void;
  locked?: boolean;
  compact?: boolean;
}) {
  const { t } = useTranslation();
  const coche = value === true;
  return (
    <div className="space-y-1" data-testid="simulator-internal-only">
      <Label className="text-xs text-slate-500">{t("admin.internalOnly.label")}</Label>
      <button
        type="button"
        disabled={locked}
        aria-pressed={coche}
        onClick={() => onChange(!coche)}
        className={`w-full flex items-center justify-center gap-2 px-3 py-2 rounded-md border ${compact ? "text-xs" : "text-sm"} font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-70 ${
          coche ? "bg-amber-50 border-amber-200 text-amber-800" : "bg-slate-50 border-slate-200 text-slate-500"
        }`}
      >
        <span className={`h-2.5 w-2.5 rounded-full ${coche ? "bg-amber-500" : "bg-slate-300"}`} />
        {coche ? t("admin.internalOnly.on") : t("admin.internalOnly.off")}
      </button>
      <p className="text-[11px] text-slate-500">{locked ? t("admin.n8nGroup.adminOnly") : t("admin.internalOnly.hint")}</p>
    </div>
  );
}
